<script lang="ts" setup>
const { loadLayout, layoutData } = useLayout()
await loadLayout()

const service = computed(() => {
  return layoutData.value?.serviceBlock
})
</script>

<template>
  <div
    v-if="service"
    class="service-support"
  >
    <img
      v-if="service?.Image?.url"
      :src="service.Image.url"
      class="service-support__image"
      :alt="service.Image?.alternativeText || ''"
      :width="service.Image?.width"
      :height="service.Image?.height"
    >
    <div class="service-support__content">
      <div
        v-if="service.Title"
        class="service-support__heading"
      >
        {{ service.Title }}
      </div>

      <p
        v-if="service?.Description?.trim()"
        class="service-support__description"
      >
        {{ service.Description }}
      </p>

      <ul
        v-if="service.PhoneNumber || service.Email"
        class="service-support__list"
      >
        <li
          v-if="service.PhoneNumber"
          class="service-support__item"
        >
          <a
            :href="`tel:${service.PhoneNumber.replace(/[\s\-]+/g, '')}`"
            class="service-support__link"
          >
            <Icon name="icon:phone" />
            {{ service.PhoneNumber }}
          </a>
        </li>
        <li
          v-if="service.Email"
          class="service-support__item"
        >
          <a
            :href="`mailto:${service.Email}`"
            class="service-support__link"
          >
            <Icon name="icon:email" />
            {{ service.Email }}
          </a>
        </li>
      </ul>

      <AppLink
        v-if="service.ButtonLink && service.ButtonText"
        :to="service.ButtonLink"
        class="service-support__cta"
      >
        {{ service.ButtonText }}
      </AppLink>
    </div>
  </div>
</template>

<style>
@import url("~layers/app/components/Service/Support.css");
</style>
